import { render, staticRenderFns } from "./CopyrightAmendmentFormFilesDetails.vue?vue&type=template&id=0c81a6d8&scoped=true&"
import script from "./CopyrightAmendmentFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormFilesDetails.vue?vue&type=style&index=0&id=0c81a6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81a6d8",
  null
  
)

export default component.exports